// This component is responsible for the actual routing
import {RouterProvider} from 'react-router';
// import HeaderOrganism from "../components/header/Header";
// import useSubscribeAccounts from "../hooks/useSubscribeAccounts";
import {useMemo} from 'react';
import useGetUser from '../hook/useGetUser';
import {firebaseAuth} from '../setup/firebase';
import {buildRoute} from '../variables/buildRoute';

export default function AppRouter() {
  const {user} = useGetUser(firebaseAuth);
  // const accounts = useSubscribeAccounts(auth?.uid);
  // const [account, setAccount] = useState<string | undefined>();
  // const isFound = Object.entries(accounts).find(([k]) => k === account);
  // const currentAccount = isFound ? isFound[1] : undefined;

  // useEffect(() => {
  //   localStorage.setItem("token", get(user, "accessToken", ""));
  // }, [user]);
  // const router = buildRoute(user);

  const router = useMemo(() => buildRoute(user), [user]);

  return <RouterProvider router={router} />;
}
